import React from 'react';

const ROWS = 6;
const COPIES_PER_ROW = 6;
const ROW_KEYS = Array.from({ length: ROWS }, (_, index) => `row-${index + 1}`);
const COPY_KEYS = Array.from(
  { length: COPIES_PER_ROW },
  (_, index) => `copy-${index + 1}`
);

export default function PlaceholderPatternOverlay({
  color = 'rgba(107, 114, 128, 0.08)',
  fontSize = 28,
  rowGap = 20,
  angle = -18,
}) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: '-14% -22%',
          transform: `rotate(${angle}deg)`,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: rowGap,
        }}
      >
        {ROW_KEYS.map((rowKey, rowIndex) => (
          <div
            key={rowKey}
            style={{
              display: 'flex',
              gap: 18,
              whiteSpace: 'nowrap',
              marginLeft: rowIndex % 2 === 0 ? '-6%' : '-1%',
            }}
          >
            {COPY_KEYS.map((copyKey) => (
              <span
                key={`${rowKey}-${copyKey}`}
                style={{
                  color,
                  fontSize,
                  fontWeight: 600,
                  letterSpacing: '0.22em',
                  textTransform: 'uppercase',
                  lineHeight: 1,
                }}
              >
                Placeholder
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
